<template>
  <div class="ace-modal" :class="{ 'ace-modal--visible': visible }" @click.self="$emit('close')">
    >
    <div class="ace-modal__window">
      <div class="ace-modal__close">
        <button @click.self="$emit('close')"></button>
      </div>
      <div class="ace-modal__content">
        <slot ref="content"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: ['visible'],
};
</script>

<style scoped lang="scss">
.ace-modal {
  $this: &;

  transition: 300ms ease opacity 300ms, 0ms ease visibility 600ms;

  background: rgba(0, 0, 0, 0.75);
  opacity: 0;

  height: 100%;
  width: 100%;

  display: block;
  visibility: hidden;

  bottom: 0;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 9998;
  &--visible {
    transition-delay: 0s;

    opacity: 1;

    visibility: visible;
    #{$this}__window {
      transform: translateX(-50%) translateY(-50%);
      transition-delay: 300ms, 0s, 300ms;

      opacity: 1;

      visibility: visible;
    }
  }
  &__window {
    transform: translateX(-50%) translateY(calc(-50% - 30px));
    transition: 300ms ease opacity 0s, 300ms ease visibility 300ms, 300ms ease transform 0s;

    background: #ffffff;
    box-shadow: 0 0 18px rgba(0, 0, 0, 0.15);
    opacity: 0;

    max-width: 600px;
    padding: 20px;
    width: 100%;

    display: flex;
    flex-direction: column;
    visibility: hidden;

    left: 50%;
    position: absolute;
    top: 50%;
    z-index: 9999;
  }
  &__close {
    position: absolute;
    right: 20px;

    button {
      cursor: pointer;

      background-color: transparent;
      background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 512 512' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill='%2302A94E' d='M443.6 387.1L312.4 255.4l131.5-130c5.4-5.4 5.4-14.2 0-19.6l-37.4-37.6c-2.6-2.6-6.1-4-9.8-4-3.7 0-7.2 1.5-9.8 4L256 197.8 124.9 68.3c-2.6-2.6-6.1-4-9.8-4-3.7 0-7.2 1.5-9.8 4L68 105.9c-5.4 5.4-5.4 14.2 0 19.6l131.5 130L68.4 387.1c-2.6 2.6-4.1 6.1-4.1 9.8 0 3.7 1.4 7.2 4.1 9.8l37.4 37.6c2.7 2.7 6.2 4.1 9.8 4.1 3.5 0 7.1-1.3 9.8-4.1L256 313.1l130.7 131.1c2.7 2.7 6.2 4.1 9.8 4.1 3.5 0 7.1-1.3 9.8-4.1l37.4-37.6c2.6-2.6 4.1-6.1 4.1-9.8-.1-3.6-1.6-7.1-4.2-9.7z'/%3E%3C/svg%3E");
      border: none;

      height: 30px;
      width: 30px;

      z-index: 999;

      appearance: none;
      svg {
        height: 100%;
        width: 100%;
      }
    }
  }
  &__content {
    flex: 1;
  }
  &__actions {
    margin-top: 30px;

    display: flex;

    justify-content: space-between;
  }
}
</style>
